<template>
    <div class="common-accordion">
        <div class="common-accordion__header" :class="{ 'is-open': isOpen }" @click="toggle">
            <span class="common-accordion__title">
                {{ title }}
            </span>

            <common-icon
                name="dropdown"
                size="medium"
                class="common-accordion__icon"
                :class="{ 'is-open': isOpen }"
            ></common-icon>
        </div>

        <transition name="accordion">
            <div v-show="isOpen" class="common-accordion__body">
                <slot></slot>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                required: true,
            },
            defaultOpen: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                isOpen: this.defaultOpen,
            }
        },

        methods: {
            toggle() {
                this.isOpen = !this.isOpen
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';
    .common-accordion {
        border: 1px solid $color--border-input;
        border-radius: 4px;
        background: $color-white;
        margin-bottom: 16px;
    }

    .common-accordion__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 14px 16px;
        cursor: pointer;
        background: $color-white;
        border-radius: 4px;
        font-weight: 500;
        color: $color--txt-base;
    }
    .common-accordion__header.is-open {
        background: #f0f6ff;
    }

    .common-accordion__icon {
        transition: transform 0.25s ease;
        font-size: 14px;
    }

    .common-accordion__icon.is-open {
        transform: rotate(180deg);
    }

    .common-accordion__body {
        padding: 16px;
    }

    .accordion-enter-active,
    .accordion-leave-active {
        transition: all 0.25s ease;
    }

    .accordion-enter,
    .accordion-leave-to {
        opacity: 0;
        max-height: 0;
    }
</style>
